// pages/AdminDashboard/components/ClientsList.jsx
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../config/firebase";
import LoadingScreen from "../../../components/common/loading/LoadingScreen";

const TableContainer = styled.div`
	overflow-x: auto;
	background: white;
	border-radius: 8px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const Table = styled.table`
	width: 100%;
	border-collapse: collapse;

	th,
	td {
		padding: 12px;
		text-align: left;
		border-bottom: 1px solid #eee;
	}

	th {
		background: #f9fafb;
		font-weight: 600;
	}
`;

const ClientsList = () => {
	const [clients, setClients] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchClients = async () => {
			try {
				const snapshot = await getDocs(collection(db, "users"));
				const clientsData = snapshot.docs
					.map((doc) => ({
						id: doc.id,
						...doc.data(),
					}))
					.filter((user) => user.role === "client");
				setClients(clientsData);
			} catch (error) {
				console.error("Error fetching clients:", error);
			} finally {
				setLoading(false);
			}
		};

		fetchClients();
	}, []);

	if (loading) return <LoadingScreen/>;

	return (
		<TableContainer>
			<Table>
				<thead>
					<tr>
						<th>Name</th>
						<th>Email</th>
						<th>Phone</th>
						<th>Join Date</th>
						<th>Subscription</th>
					</tr>
				</thead>
				<tbody>
					{clients.map((client) => (
						<tr key={client.id}>
							<td>{client.name}</td>
							<td>{client.email}</td>
							<td>{client.phone}</td>
							<td>{new Date(client.createdAt).toLocaleDateString()}</td>
							<td>{client.subscriptionPlan || "None"}</td>
						</tr>
					))}
					{clients.length === 0 && (
						<tr>
							<td colSpan="5" style={{ textAlign: "center", padding: "24px" }}>
								No clients found
							</td>
						</tr>
					)}
				</tbody>
			</Table>
		</TableContainer>
	);
};

export default ClientsList;
